var params = require('./params.json')
params.genesisState = require('./genesisState.json')
params.bootstrapNodes = require('./bootstrapNodes.json')
module.exports = params



//////////////////
// WEBPACK FOOTER
// ./node_modules/ganache-core/node_modules/ethereum-common/index.js
// module id = 17
// module chunks = 0